(function () {

    'use strict';

    angular.module('Services').service('AccountsPayableShipmentsTableService', AccountsPayableShipmentsTableService);

    AccountsPayableShipmentsTableService.$inject = ['TableLiteFactory', '$filter','AccountingService'];

    function AccountsPayableShipmentsTableService(TableLiteFactory, $filter,AccountingService) {
        return function (invoiceId) {
            const tableData = {
                optionAddOns: {},
                config: {
                    noFooter: false,
                    noFilter: true,
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: true,
                    noTableFooter: true,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Consignment No.',
                        viewName: 'consignmentId'
                    },
                    {
                        label: 'Service Code',
                        viewName: 'serviceCode'
                    },
                    {
                        label: 'Ex Tax Total',
                        viewName: 'amountStr',
                        filterName: 'amount'
                    },
                    {
                        label: 'Customer',
                        viewName: 'customerName'
                    },
                    {
                        label: 'Margin %',
                        viewName: 'marginPercent'
                    },
                    {
                        label: 'Margin Value',
                        viewName: 'marginValue'
                    },
                    {
                        label: 'Billed',
                        viewName: 'billed'
                    },
                    {
                        label: 'Date Invoiced',
                        viewName: 'dateOfInvoice'
                    }
                ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.AccountsPayable.getPayableInvoiceShipments,
                callbackFormat: ['id','success','error','filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                },
                paramId:invoiceId,
            });

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data)
                    return null;
                angular.forEach(data.content, function (row) {
                    row.consignmentId = row.consignmentId || 'N/A';
                    row.serviceCode = row.serviceCode || 'N/A';
                    row.amountStr = $filter('bbaCurrency')(row.amount || 0);
                    row.customerName = row.company && row.company.name;
                    row.marginPercent = (row.shippingCost.percentMargin || 0) + '%';
                    row.marginValue = $filter('bbaCurrency')(row.shippingCost.valueMargin || 0);
                    row.billed = row.billed ? 'Yes' : 'No';
                    row.dateOfInvoice = row.dateOfInvoice ? $filter('bbaDate')(row.dateOfInvoice) : 'N/A';
                    row.href = `/accounting/accounts-payable/shipment/${row.id}`;
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountsPayableShipmentsTableService.js